import VuiHeader from "../../@vodea/vodea-ui/components/Header";
import {Outlet} from "react-router";
/*import VuiFooter from "../../@vodea/vodea-ui/components/Footer";*/

const ErrorLayout: React.FC<any> = () => {
    return (
        <section id={'auth-layout'}>
            <VuiHeader/>

            <div className="container-wrapper">
                <div className="container">
                    <Outlet/>
                </div>
            </div>

            {/*<VuiFooter/>*/}
        </section>
    )
}

export default ErrorLayout
